import Logging from "~app/core/logging";

import { Bundle, bindBundleContext } from "./Bundle";
import ReactLocalizer from "./ReactLocalizer";

const makeKey = (name, format) => `${name}::${format || "raw"}`;

export default class ReactBundle extends Bundle {
  constructor({ resources, contexts = [], language }) {
    super();
    this.language = language;
    this.descriptors = resources;
    this.assets = {};
    this.contexts = contexts;
  }

  async prepare() {
    const strings = await this.preload("strings", "json");
    this.localizer = new ReactLocalizer({
      language: this.language,
      strings,
    });

    // load all resources
    await Promise.all(
      Object.entries(this.descriptors).flatMap(([name, descriptor]) =>
        (descriptor.preload || []).map(fmt => this.preload(name, fmt))
      )
    );

    this.contexts.forEach(ctx => bindBundleContext(ctx, this));
  }

  // pull a specific version of an asset from the descriptor based on language
  _selectRequire(descriptor) {
    const { languages, require } = descriptor;
    const result = languages && languages[this.language];
    const resolve = x => (typeof x === "function" ? x() : x);
    if (result) {
      return resolve(result);
    }
    return resolve(require);
  }

  async preload(name, format = null) {
    const key = makeKey(name, format);
    let asset = this.assets[key];
    if (asset) return asset.value;

    const descriptor = this.descriptors[name];
    Logging.assert(descriptor, `could not find asset=${name}`);

    let value = this._selectRequire(descriptor);
    Logging.assert(
      value,
      `unable to find acceptable asset=${name} for language=${this.language}`
    );

    this.assets[key] = {
      value,
      count: 1,
    };
    return value;
  }

  get = (name, format = null) => {
    const key = makeKey(name, format);
    const asset = this.assets[key];
    if (!asset && format === null) {
      const descriptor = this.descriptors[name];
      Logging.assert(descriptor, `could not find asset=${name}`);
      const value = this._selectRequire(descriptor);
      Logging.assert(
        value,
        `unable to find acceptable asset=${name} for language=${this.language}`
      );
      return value;
    }
    Logging.assert(asset, `could not find asset=${name} with format=${format}`);
    asset.count += 1;
    return asset.value;
  };

  release = (name, format = null) => {
    if (format === null) return;
    const key = makeKey(name, format);
    const asset = this.assets[key];
    Logging.assert(
      asset,
      `unbalanced release asset=${name} with format=${format}`
    );
    if (asset.count === 1) {
      delete this.assets[key];
    }
 else {
      asset.count -= 1;
    }
  };

  destroy = () => {
    this.assets = {};
    this.contexts.forEach(ctx => Bundle.unbindBundleContext(ctx, this));
  };
}



// WEBPACK FOOTER //
// ./src/ReactBundle.js